import React from 'react'
import feature1 from "../../img/feature-ils-1.svg";
import feature2 from "../../img/feature-ils-2.svg";
import feature3 from "../../img/feature-ils-3.svg";

const Feature = () => {
  return (
<section className="feature my-5">
        <div className="container">
          <div className="text-center my-3">
            <h3 className="fw-bold fs-2">
              أسرع, وأسهل طريقة لشحن منتجاتكم الى عملائكم
            </h3>
            <p className="text text-black-50 fs-6">
              تتميز شركتنا بتقديم تجربة شحن لا مثيل لها لعملاء المتاجر
              الالكترونية. نوفر لكم جميع الأدوات اللازمة لتتجاوز توقعات عملائك
            </p>
          </div>

          <div className="row align-items-center text-center">
            <div className="col-md-4">
              <div className="crd">
                <div className="img">
                  <img src={feature1} alt="" />
                </div>
                <div className="info my-3">
                  <h3 className="fw-bold fs-4">ادخل معلومات الشحنة</h3>
                  <p className="dis">
                    ادخل معلومات الشحنه و وزنها و عنوان العميل المراد الشحن له
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="crd">
                <div className="img">
                  <img src={feature2} alt="" />
                </div>
                <div className="info my-3">
                  <h3 className="fw-bold fs-4">اختر الناقل المناسب</h3>
                  <p className="dis">
                    قم بتصفح العديد من الناقلين و اختر السعر المناسب لشحنتك
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="crd">
                <div className="img">
                  <img src={feature3} alt="" />
                </div>
                <div className="info my-3">
                  <h3 className="fw-bold fs-4">اطبع بوليصة الشحن</h3>
                  <p className="dis">
                    اطبع بوليصة الشحن و استعد لشحن الطلب لعمليك و تتبع الطلب
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  )
}

export default Feature